"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_web_components_1 = require("@nimles/react-web-components");

var react_web_components_2 = require("@nimles/react-web-components");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_redux_1 = require("react-redux");

var react_web_components_3 = require("@nimles/react-web-components");

var ShoppingCart_1 = require("./ShoppingCart");

var Link_1 = require("./Link");

var CartLabel = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  height: 48px;\n  padding: 0 8px;\n\n  @media (min-width: ", "px) {\n    padding: 0 32px;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  height: 48px;\n  padding: 0 8px;\n\n  @media (min-width: ", "px) {\n    padding: 0 32px;\n  }\n"])), function (props) {
  return props.theme.thresholds.sm;
});
var CartIcon = styled_1.default(react_fontawesome_1.FontAwesomeIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 20px;\n"], ["\n  font-size: 20px;\n"])));
var CartQuantity = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  left: 8px;\n  top: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 22px;\n  min-width: 22px;\n  border-radius: 50%;\n  font-size: 12px;\n  background: rgba(255, 0, 0, 0.8);\n  color: white;\n\n  @media (min-width: ", "px) {\n    left: 32px;\n  }\n"], ["\n  position: absolute;\n  left: 8px;\n  top: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 22px;\n  min-width: 22px;\n  border-radius: 50%;\n  font-size: 12px;\n  background: rgba(255, 0, 0, 0.8);\n  color: white;\n\n  @media (min-width: ", "px) {\n    left: 32px;\n  }\n"])), function (props) {
  return props.theme.thresholds.sm;
});
var CartSummary = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding-left: 20px;\n"], ["\n  padding-left: 20px;\n"])));
var CartPrice = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 14px;\n  font-weight: normal;\n"], ["\n  font-size: 14px;\n  font-weight: normal;\n"])));
var CartMenu = styled_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background: #fff;\n  padding: 10px;\n  border: 1px solid lightgrey;\n"], ["\n  background: #fff;\n  padding: 10px;\n  border: 1px solid lightgrey;\n"])));

exports.ShoppingCartMenu = function (_a) {
  var cart = react_redux_1.useSelector(function (_a) {
    var carts = _a.carts;
    return carts.selected;
  });

  var gotoCart = function gotoCart() {
    Link_1.navigate('/cart');
  };

  var handleCheckout = function handleCheckout() {
    Link_1.navigate('/checkout');
  };

  var totalQuantity = cart && cart.items && cart.items.reduce(function (sum, item) {
    return sum + item.quantity;
  }, 0);
  var totalAmount = cart && cart.items && cart.items.reduce(function (sum, item) {
    return sum + item.product.netPrice * item.quantity;
  }, 0);
  return react_1.default.createElement(react_web_components_3.DropdownMenu, {
    align: "right",
    menu: function menu() {
      return react_1.default.createElement(CartMenu, null, react_1.default.createElement(react_web_components_2.Row, {
        justify: "flex-end"
      }, react_1.default.createElement(react_web_components_2.Column, null)), react_1.default.createElement(ShoppingCart_1.ShoppingCart, {
        cart: cart
      }), react_1.default.createElement(react_web_components_2.Row, {
        justify: "flex-end"
      }, react_1.default.createElement(react_web_components_2.Column, null, react_1.default.createElement(react_web_components_1.Button, {
        border: true,
        primary: true,
        onClick: gotoCart
      }, "Open cart")), react_1.default.createElement(react_web_components_2.Column, null, react_1.default.createElement(react_web_components_1.Button, {
        raised: true,
        primary: true,
        onClick: handleCheckout
      }, "Checkout"))));
    }
  }, react_1.default.createElement(CartLabel, null, totalQuantity ? react_1.default.createElement(CartQuantity, null, totalQuantity) : null, react_1.default.createElement(CartIcon, {
    icon: free_solid_svg_icons_1.faShoppingBasket
  }), react_1.default.createElement(CartSummary, null, totalAmount ? react_1.default.createElement(CartPrice, null, totalAmount + ' kr') : null, react_1.default.createElement("div", null, "Inkl. moms"))));
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;